import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const PROMOTIONS_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for namespace (e.g. accountGroupId)',
);

export const PROMOTIONS_PARENT_NAMESPACE_TOKEN = new InjectionToken<string | Observable<string>>(
  '[Promotions]: token for parent namespace (empty if partner context, partnerId if SMB context)',
);

export const PROMOTIONS_COUNTRY_TOKEN = new InjectionToken<Observable<string | null>>(
  '[Promotions]: token for current business country name',
);

export interface FlyerBranding {
  bgColor?: string;
  textColor?: string;
}

export const FORM_FLYER_BRANDING_TOKEN = new InjectionToken<Observable<FlyerBranding>>(
  '[Promotions]: token for flyer branding defaults (bgColor, textColor — without # prefix)',
);

